import {AxiosCall} from '../axios';
import {ServiceSuccessResponseType} from './service-mappers/BaseMapper';
import {ArrayResponse} from './service-mappers/CommonServiceMapper';
import {FNPDPotentialStatement} from './service-mappers/FNPDServiceMappers';

export const apiFNPDPotentialStatements = async (
  operation: 'DATA' | 'DOWNLOAD' | 'UPDATE_ALL',
  clinic_group_id: number,
  clinic_id: number,
  threshold_amount?: string,
  statements?: string,
  limit?: number,
  offset?: number,
  options?: any
): Promise<
  ServiceSuccessResponseType<ArrayResponse<FNPDPotentialStatement> | null>
> => {
  let params = '';
  if (threshold_amount) {
    params += `threshold_amount=${threshold_amount}&`;
  }
  if (statements) {
    params += `no_of_last_statement=${statements}&`;
  }
  if (operation === 'DATA') {
    return AxiosCall.get(
      `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/fn-pd-check?${params}limit=${limit}&offset=${offset}`
    );
  } else if (operation === 'DOWNLOAD') {
    return AxiosCall.get(
      `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/fn-pd-check/download?${params}`
    );
  } else {
    return AxiosCall.post(
      `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/fn-pd-check/update-all?${params}`,
      {}
    );
  }
};
